module.exports = __webpack_public_path__ + "img/monterey-g-series-rectangle-front-angle.e7fcb689.png";